<!-- 头像 -->
<template>
  <a-dropdown
    :trigger="['hover']"
    placement="bottomRight"
    @visibleChange="visibleChangeFunc"
  >
    <div class="user-img-box cursor-pointer">
      <img
        :src="userInfo.avatar"
        alt=""
        class=""
        @error="loadDefaultAvator"
        v-if="userInfo.avatar"
      />
    </div>
    <template #overlay>
      <div class="user-box">
        <div class="info-box display-flex margin-b-20">
          <div class="w-12 h-12 border-radius-50">
            <img
              :src="userInfo.avatar"
              alt=""
              class="w-full h-full border-radius-50"
              @error="loadDefaultAvator"
            />
          </div>
          <div class="margin-l-16">
            <div class="flex-align-center">
              <div class="text-1c2129 font-semibold text-base">
                {{ userInfo.nickname }}
              </div>
              <div class="cert-img-box" v-if="false">
                <img
                  :src="
                    userInfo.certify == 'y'
                      ? require('../../images/home/certification-img.png')
                      : require('../../images/home/no-certification-img.png')
                  "
                  alt=""
                />
              </div>
              <div class="vip-img-box" v-if="userInfo.level > 0">
                <img :src="vipImgMap[userInfo.level]" alt="" />
              </div>
            </div>
            <div class="text-86909c text-xs padding-t-8">
              {{ userInfo.phone || userInfo.email }}
            </div>
          </div>
        </div>

        <div class="level-box" v-if="false">
          <div
            class="level-item"
            :class="'person-' + userLevel.code"
            @click="toHome(1)"
          >
            <div class="font-size-13 color-333 text-center flex-center">
              <img
                v-if="userLevel.name == '免费版'"
                src="../../images/home/v0.png"
                width="16"
              />
              <img v-else src="../../images/home/v1.png" width="16" />
              <span class="margin-l-2">个人{{ userLevel.name }}</span>
            </div>
            <p class="time text-center margin-t-5" v-if="userLevel.endDate > 0">
              {{ dayjs(userLevel.endDate * 1).format('YYYY-MM-DD') }}
              到期
            </p>
            <p class="time text-center margin-t-5" v-else>永久有效</p>
          </div>
          <div
            class="level-item"
            :class="'team-' + projectLevel.code"
            @click="toHome(2)"
          >
            <p class="font-size-13 color-333 text-center flex-center">
              <img
                v-if="projectLevel.name == '免费版'"
                src="../../images/home/v0.png"
                width="16"
              />
              <img
                v-else-if="projectLevel.name == '初创版'"
                src="../../images/home/v1.png"
                width="16"
              />
              <img
                v-else-if="projectLevel.name == '企业版'"
                src="../../images/home/v2.png"
                width="16"
              />
              <img
                v-else-if="projectLevel.name == '旗舰版'"
                src="../../images/home/v3.png"
                width="16"
              />
              <img
                v-else-if="projectLevel.name == '定制版'"
                src="../../images/home/vip.png"
                width="16"
              />
              <span class="margin-l-2">团队{{ projectLevel.name }}</span>
            </p>
            <p
              class="time text-center margin-t-5"
              v-if="projectLevel.endDate > 0"
            >
              {{ dayjs(projectLevel.endDate * 1).format('YYYY-MM-DD') }}到期
            </p>
            <p class="time text-center margin-t-5" v-else>永久有效</p>
          </div>
        </div>

        <div
          class="info-href h-10 rounded-md flex-align-center"
          @click="userToPageFunc('tsp-dashboard')"
          v-if="
            settingDetail.settings.user_info_more.value === 'true' &&
            isPersonalEnterprise
          "
        >
          <div class="img-href-box">
            <img src="../../images/home/user-1.png" alt="" />
          </div>
          <div class="margin-l-12 font-size-14 text-1c2129">我的工作台</div>
        </div>
        <div
          class="info-href h-10 rounded-md flex-align-center"
          @click="userToPageFunc('wd-jl')"
          v-if="
            settingDetail.settings.user_info_more.value === 'true' &&
            isPersonalEnterprise
          "
        >
          <div class="img-href-box">
            <img src="../../images/home/user-2.png" alt="" />
          </div>
          <div class="margin-l-12 font-size-14 text-1c2129">个人简历</div>
        </div>
        <div
          class="info-href h-10 rounded-md flex-align-center"
          @click="userToPageFunc('wd-set')"
          v-if="
            settingDetail.settings.user_info_more.value === 'true' &&
            isPersonalEnterprise
          "
        >
          <div class="img-href-box">
            <img src="../../images/home/user-3.png" alt="" />
          </div>
          <div class="margin-l-12 font-size-14 text-1c2129">接单设置</div>
        </div>
        <div class="line-box"></div>
        <div
          class="info-href h-10 rounded-md flex-align-center"
          @click="userToPageFunc('pe-invite-politely')"
          v-if="
            settingDetail.settings.user_info_more.value === 'true' &&
            isPersonalEnterprise
          "
        >
          <div class="img-href-box">
            <img src="../../images/home/user-4.png" alt="" />
          </div>
          <div
            class="margin-l-12 font-size-14 text-1c2129 display-flex align-center"
          >
            <span class="padding-r-8">邀请好友</span>
            <div class="jl-img-box">
              <img src="../../images/home/user-4-jl.png" alt="" />
            </div>
          </div>
        </div>
        <div
          class="info-href h-10 rounded-md flex-align-center"
          @click="userToPageFunc('tsp-home')"
          v-if="
            settingDetail.settings.user_info_more.value === 'true' &&
            isPersonalEnterprise
          "
        >
          <div class="img-href-box">
            <img src="../../images/home/user-5.png" alt="" />
          </div>
          <div class="margin-l-12 font-size-14 text-1c2129">官方网站</div>
        </div>
        <div
          class="info-href h-10 rounded-md flex-align-center"
          @click="userToPageFunc('tsp-center')"
        >
          <div class="img-href-box">
            <img src="../../images/home/user-6.png" alt="" />
          </div>
          <div class="margin-l-12 font-size-14 text-1c2129">个人中心</div>
        </div>
        <div class="line-box"></div>
        <div
          class="font-size-14 text-center padding-b-12 cursor-pointer exit-btn"
          @click="exitFunc"
        >
          退出登录
        </div>
      </div>
    </template>
  </a-dropdown>
</template>

<script setup name="navigateDrop">
  import { computed, onMounted, reactive, toRefs } from 'vue'
  import { useStore } from 'vuex'
  import dayjs from 'dayjs'

  import {
    logout,
    getUserInfo,
    levelPrivilege,
    enterpriseList,
  } from '../../http/api'
  import { trackStatistics } from '@/utils/tracker/index'
  import { trackMap } from '@/utils/tracker/trackData'

  const store = useStore()
  const userInfo = computed(() => store.state.comm.userInfo)
  const settingDetail = computed(() => {
    return store.state.comm.settingDetail
  })

  let props = defineProps({
    fromPage: String,
  })

  const herfObj = {
    'wd-account': '/go/wd_pc_login/account/index', // 账户提现
    'pe-recharge': '/go/wealth_pc_login/recharge', // 译力充值
    'pe-invite-politely': '/go/pe_pc_login/pe?redirect=invitePolitely', // 邀请好友
    'wd-set': '/go/wd_pc_login/users/likeSetting', // 接单设置
    'wd-jl': '/go/wd_pc_login/web/userCenter/resume', // 个人简历
    'tsp-home': '/go/tsp_pc_login_option/home', // 官方网站
    'tsp-about': '/go/tsp_pc_login_option/about', // 关于我们
    'tsp-center': '/go/tsp_pc_login/center', // 个人中心
    'tsp-dashboard': '/go/tsp_pc_login/dashboard', // 我的工作台
  }

  const vipImgMap = {
    1: require('../../images/home/T1-img.png'),
    2: require('../../images/home/T2-img.png'),
    3: require('../../images/home/T3-img.png'),
    4: require('../../images/home/T4-img.png'),
    5: require('../../images/home/T5-img.png'),
    6: require('../../images/home/T6-img.png'),
    7: require('../../images/home/T7-img.png'),
    8: require('../../images/home/T8-img.png'),
    9: require('../../images/home/T9-img.png'),
  }

  const state = reactive({
    userLevel: {},
    projectLevel: {},
    enterpriseArr: [],
    isPersonalEnterprise: false,
  })

  // 头像下拉内容跳转
  const userToPageFunc = (name) => {
    trackStatistics({
      event_code: 'topNavigation',
      scene_code: trackMap[name] || '',
    })
    if (name === 'tsp-center' && !isPersonalEnterprise) {
      window.open(herfObj[name] + '?customCenter=1', '_blank')
      return
    }
    window.open(herfObj[name], '_blank')
  }

  // 注销登陆
  const exitFunc = async () => {
    trackStatistics({
      event_code: 'topNavigation',
      scene_code: trackMap['tsp-logout'],
    })
    await logout({})
    localStorage.clear()
    window.location.href =
      '/go/iollab_pc_login_option' + location.pathname + location.search
  }

  // 加载默认图片
  const loadDefaultAvator = () => {
    userInfo.value.avatar = require('../../images/pe_default_photo.png')
  }

  const getUserInfoFunc = () => {
    getUserInfo({ token: localStorage.token }).then((res) => {
      if (!res.id) {
        localStorage.token = ''
        localStorage.userInfo = ''
        store.commit('comm/changeKey', { token: '' })
        store.commit('comm/changeKey', { userInfo: '' })
      } else {
        localStorage.userInfo = JSON.stringify(res)
        store.commit('comm/changeKey', { userInfo: res })
      }
    })
  }

  // 获取会员等级
  const getLevelPrivilegeFunc = () => {
    levelPrivilege().then((res) => {
      state.userLevel = res.personal
      state.projectLevel = res.team
    })
  }

  const visibleChangeFunc = (flag) => {
    if (flag) {
      getUserInfoFunc()
      // getLevelPrivilegeFunc()
      trackStatistics({
        event_code: 'topNavigation',
        scene_code: trackMap['tsp-photo'],
      })
      getEnterpriseList()
    }
  }

  const toHome = (tab) => {
    window.open(`/go/tsp_pc_login/home/price?tab=${tab}`, '_blank')
  }

  // 获取企业列表
  const getEnterpriseList = () => {
    enterpriseList()
      .then((res) => {
        const data = res.data || []
        state.enterpriseArr = data
        state.isPersonalEnterprise = data.every(
          (item) => item.selected === false
        )
      })
      .catch(() => {})
  }

  onMounted(() => {
    // getLevelPrivilegeFunc()
    getEnterpriseList()
  })

  const { userLevel, projectLevel, isPersonalEnterprise } = toRefs(state)
</script>

<style scoped lang="less">
  .user-box {
    width: 320px;
    padding: 30px 20px 0;
    background: #ffffff;
    box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.12);
    border-radius: 12px;
    border: 1px solid #f2f3f5;
  }
  .info-href {
    cursor: pointer;
    &:hover {
      background: #f2f3f5;
    }
  }
  .line-box {
    height: 1px;
    background-color: #eee;
    margin: 12px 0;
  }
  .w-full {
    width: 100%;
  }
  .h-full {
    height: 100%;
  }
  .border-radius-50 {
    border-radius: 50%;
  }
  .rounded-md {
    border-radius: 6px;
  }
  .w-4 {
    width: 16px;
  }
  .h-4 {
    height: 16px;
  }
  .w-9 {
    width: 36px;
  }
  .h-9 {
    height: 36px;
  }
  .w-12 {
    width: 48px;
  }
  .h-12 {
    height: 48px;
  }
  .h-10 {
    height: 40px;
  }
  .img-href-box {
    width: 16px;
    height: 16px;
    margin-left: 12px;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .text-1c2129 {
    color: #1c2129;
  }
  .exit-btn {
    color: #86909c;
    &:hover {
      color: #f55c3f;
    }
  }
  .user-img-box {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    img {
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
  .cert-img-box,
  .vip-img-box {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    margin-left: 8px;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .jl-img-box {
    width: 28px;
    height: 16px;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .level-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    .level-item {
      padding: 12px 0;
      width: 130px;
      height: 66px;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        transform: translateY(-4px);
      }
      &.person-free {
        background: linear-gradient(180deg, #e7f6ff 0%, #f3f9fe 100%);
      }
      &.person-premium {
        background: linear-gradient(180deg, #e7f2ff 0%, #f3f6fe 100%);
      }
      &.team-free {
        background: linear-gradient(180deg, #e7f6ff 0%, #f3f9fe 100%);
      }
      &.team-startup {
        background: linear-gradient(180deg, #e7f2ff 0%, #f3f6fe 100%);
      }
      &.team-enterprise {
        background: linear-gradient(180deg, #fff3e7 0%, #fef8f3 100%);
      }
      &.team-ultimate {
        background: linear-gradient(180deg, #e6ebff 0%, #f4f2ff 100%);
      }
      &.team-ultimate-plus {
        background: linear-gradient(180deg, #e7e6ff 0%, #f8f2ff 100%);
      }
      .time {
        font-size: 12px;
        color: #bbb;
      }
    }
  }
</style>
